module.exports = __webpack_public_path__ + "static/media/19_tellme_a.ec9561d4.ogg";